<template>
    <form @submit.prevent="submitForm" id='SingleItem'>
    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Scan Items
      </label>
      <select v-model="transferToReceive" class="form-control" id="input-transfer-to-receive">
        <option v-for="(transferId, index) in transferToReceiveList" :value="transferId" :selected="0 == index">
          {{ transferId }}
        </option>
      </select>
    </div>

    <div class="mb-3">
      <label for="input-scan-bin" class="form-label">
        Scan Bin
      </label>
      <input type="inputScanBin" class="form-control" id="input-scan-bin">
    </div>
    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="submit" class="btn btn-success w-100 btn-finalize-receipt">
        Put Away Item
      </button>
    </div>
  </form>
</template>
<script>
  export default {
    name: 'Single',
    data() {
      return {
        sku : '',
        transferToReceive : '',
        transferToReceiveList : [
          '21234234-23',// TODO: Temp
        ],
        destinationForTransfer : [],
        scannedSkus : [],
        selectedSkus : [],
      }
    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku)
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) { //TODO: not working
            this.scannedSkus.push(sku)
          }
        }
      },
      validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.addSku(this.sku)
          this.sku = ''
        }
      },
      submitForm() {
        const {
          sku,
          transferToReceive,
          destinationForTransfer,
          scannedSkus
        } = this
        console.log('ReceiveTransfer', scannedSkus, transferToReceive, destinationForTransfer)
      }
    }
  }
</script>